import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { overviewFieldLabelTypography } from './overviewFieldStyles';

/**
 * Styling for the Account Overview logo field: the label row (label + Edit/Remove links),
 * the rendered logo preview, and the inline "Upload Image" affordance. All tokens come from
 * `THEME`; the 70px logo cap mirrors the legacy `AccountLogoField`.
 */
export const accountLogoFieldStyles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	labelRow: {
		...overviewFieldLabelTypography,
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
	},
	actions: {
		display: 'flex',
		gap: THEME.spacing.xs,
	},
	logo: {
		backgroundColor: THEME.colors.background.light,
		maxHeight: 70,
		// Fixed cap (not a % of the card): the Customizations card is full-width, so the legacy
		// `maxWidth: '60%'` stretched the logo across it. 220px keeps it compact at the 70px height.
		maxWidth: 220,
		objectFit: 'contain',
		width: 'auto',
		height: 'auto',
	},
	link: {
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.xs,
		// Override the components-v2 Button's fixed height/padding so these sit inline like links.
		height: 'auto',
		padding: 0,
		textDecoration: 'none',
		':hover': {
			color: THEME.colors.hover.main,
		},
	},
	dialogActions: {
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'flex-end',
	},
});
